import { mapActions } from 'vuex'
import * as mutationTypes from '@/store/mutation-types'

export default {
  methods: {
    ...mapActions({
      fetchUserData: 'fetchUserData',
      enums: 'enums',
      currencies: 'currencies'
    }),
    async completeAuthentication (data) {
      localStorage.setItem('token', data.token)
      await this.fetchUserData()
      await this.enums()
      await this.currencies()
      this.$store.commit(mutationTypes.LOGIN, true)
      if (data.isGuest) {
        await this.$router.push({ name: 'GuestHome' })
      } else if (this.$store.getters.isAdmin || this.$store.getters.isCustomerService) {
        await this.$router.push({ name: 'CustomerServiceDashboard' })
      } else {
        await this.$router.push({ name: 'Home' })
      }
    },
    decodeBase64Param (value) {
      if (!value) {
        return ''
      }
      try {
        const binary = atob(value)
        const bytes = Uint8Array.from(binary, char => char.charCodeAt(0))
        return new TextDecoder().decode(bytes)
      } catch {
        return ''
      }
    }
  }
}
